import React from 'react';
import { css } from 'linaria';
import {
  AlignBottomIcon,
  DropIcon,
  ShieldCheckIcon,
  StarFourIcon,
  SwatchesIcon,
  ThermometerColdIcon,
  ThermometerHotIcon,
  WindIcon,
} from '@fronton/icons-react';
import { CEILINGS_CDN_PATH } from '../../ceilings-constants';

export const CEILING_TYPES_CARD_LIST = [
  {
    imgSrc: `${CEILINGS_CDN_PATH}/types/1.jpg/1.jpg`,
    alt: 'types-section.pvh.title',
    title: 'types-section.pvh.title',
    descriptionList: [
      {
        leftIcon: <AlignBottomIcon size="l" />,
        text: 'types-section.pvh.list.item1',
      },
      {
        leftIcon: <DropIcon size="l" />,
        text: 'types-section.pvh.list.item2',
      },
      {
        leftIcon: <ThermometerHotIcon size="l" />,
        text: 'types-section.pvh.list.item3',
      },
      {
        leftIcon: <StarFourIcon size="l" />,
        text: 'types-section.pvh.list.item4',
      },
      {
        leftIcon: <SwatchesIcon size="l" />,
        text: 'types-section.pvh.list.item5',
      },
      {
        leftIcon: <ThermometerColdIcon size="l" />,
        text: 'types-section.pvh.list.item6',
      },
      {
        leftIcon: <WindIcon size="l" />,
        text: 'types-section.pvh.list.item7',
      },
      {
        leftIcon: <ShieldCheckIcon size="l" />,
        text: 'types-section.pvh.list.item8',
      },
    ],
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/types/2.jpg/2.jpg`,
    alt: 'types-section.textile.title',
    title: 'types-section.textile.title',
    descriptionList: [
      {
        leftIcon: <AlignBottomIcon size="l" />,
        text: 'types-section.textile.list.item1',
      },
      {
        leftIcon: <DropIcon size="l" />,
        text: 'types-section.textile.list.item2',
      },
      {
        leftIcon: <ThermometerHotIcon size="l" />,
        text: 'types-section.textile.list.item3',
      },
      {
        className: css`
          @media (--only-tablet) {
            height: 72px;
          }
        `,
        leftIcon: <StarFourIcon size="l" />,
        text: 'types-section.textile.list.item4',
      },
      {
        leftIcon: <SwatchesIcon size="l" />,
        text: 'types-section.textile.list.item5',
      },
      {
        leftIcon: <ThermometerColdIcon size="l" />,
        text: 'types-section.textile.list.item6',
      },
      {
        leftIcon: <WindIcon size="l" />,
        text: 'types-section.textile.list.item7',
      },
      {
        leftIcon: <ShieldCheckIcon size="l" />,
        text: 'types-section.textile.list.item8',
      },
    ],
  },
];
